<template>
	<el-button
		v-if="!$apollo.loading"
		:loading="loading"
		@click="toggleCheck"
		:icon="enabled ? 'fe fe-zap-off fe-just-off' : 'fe fe-zap fe-just-off'"
		:type="!enabled ? 'success' : 'danger'"
	>{{ enabled ? "Disable automated MIS sync" : "Enable automated MIS sync" }}</el-button>
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
export default {
	data() {
		return {
			loading: false,
			enabled: null
		};
	},

	apollo: {
		enabled: {
			query: gql`
				{
					Settings {
						id
						auto_enabled
					}
				}
			`,
			update: r => _.cloneDeep(r.Settings.auto_enabled)
		}
	},

	methods: {
		toggleCheck() {
			if (this.enabled) {
				return this.toggle();
			}

			this.$confirm(
				`Enable automatic mode to automatically create and delete users when they are added and removed in your schools 
				MIS. If you have enabled the creation of users in Settings > Advanced, any users not already matched (or ignored) 
				will be created. If you have enabled the deletion of users in Settings > Advanced Settings, any matched users 
				will be suspended (and later deleted) if the user is no longer visible in your MIS.`,
				"Warning",
				{
					confirmButtonText: "OK",
					cancelButtonText: "Cancel",
					type: "warning"
				}
			).then(() => {
				this.toggle();
			});
		},
		toggle() {
			this.loading = true;
			this.$apollo
				.mutate({
					mutation: gql`
						mutation EnableAutomaticMode($enabled: Boolean!) {
							EnableAutomaticMode(enabled: $enabled)
						}
					`,
					variables: {
						enabled: this.enabled ? false : true
					},
					update: (store, { data: { EnableAutomaticMode } }) => {
						this.enabled = this.enabled ? false : true;
					}
				})
				.then(r => {
					this.loading = false;
				})
				.catch(e => {
					this.loading = false;
					this.$message.error("Failed action");
				});
		}
	}
};
</script>
